import { loadConfig, saveConfig, buildLLMConfig } from './config.js';
import { LLMClient } from './llm/llmClient.js';
import { createGameState } from './game/gameState.js';
import { ViewManager } from './views/viewManager.js';
import { App } from './app.js';

const config = loadConfig();
const llmConfig = buildLLMConfig(config);
const llmClient = new LLMClient(llmConfig);
const gameState = createGameState();
const viewManager = new ViewManager(document.getElementById('app'), config.stealthMode);

const app = new App(
  config,
  (newConfig) => {
    saveConfig(newConfig);
    // 重新创建 LLMClient 以应用新配置
    const updatedLlmConfig = buildLLMConfig(newConfig);
    app.llmClient = new LLMClient(updatedLlmConfig);
  },
  llmClient,
  gameState,
  viewManager,
);

app.init();
